import { useParams } from "@tanstack/react-router";
import { SkillDetailView } from "@/components/skills/detail/SkillDetailView";

export function SkillDetailPage() {
  const params = useParams({ strict: false });
  const slug = typeof params.id === "string" ? params.id : "";
  return <SkillDetailView slug={slug} />;
}
